import { defineMessages } from 'react-intl';

export default defineMessages({
  universalBenefitBoxHeader: {
    id: 'rewards.universalBenefitBox.header',
    defaultMessage: 'All Levels Receive',
    description: 'The header for the Universal Benefit Box benefits section',
  },
  freeMondayHeading: {
    id: 'rewards.universalBenefitBox.freeMonday.heading',
    defaultMessage: 'Free mod Monday',
    description: 'Heading for free mod Monday benefit card',
  },
  freeMondayBody: {
    id: 'rewards.universalBenefitBox.freeMonday.body',
    defaultMessage:
      'Receive Stars for every $1 spent, plus earn extra Stars by participating in our challenges, games and more!',
    description: 'Body text for free mod Monday benefit card',
  },
  personalizedGamesHeading: {
    id: 'rewards.universalBenefitBox.personalizedGames.heading',
    defaultMessage: 'Personalized games',
    description: 'Heading for personalized games benefit card',
  },
  personalizedGamesBody: {
    id: 'rewards.universalBenefitBox.personalizedGames.body',
    defaultMessage:
      'Redeem your Stars for Rewards—like free food, drinks, and more! Start redeeming with as little as 25 Stars!',
    description: 'Body text for personalized games benefit card',
  },
  doubleStarPersonalCupHeading: {
    id: 'rewards.universalBenefitBox.doubleStarPersonalCup.heading',
    defaultMessage: 'Double star with personal cup',
    description: 'Heading for double star with personal cup benefit card',
  },
  doubleStarPersonalCupBody: {
    id: 'rewards.universalBenefitBox.doubleStarPersonalCup.body',
    defaultMessage:
      "As you earn Stars, you'll work your way through our tiers, where your benefits will grow as you progress.",
    description: 'Body text for double star with personal cup benefit card',
  },
  coffeeLoopHeading: {
    id: 'rewards.universalBenefitBox.coffeeLoop.heading',
    defaultMessage: 'Coffee loop',
    description: 'Heading for coffee loop benefit card',
  },
  coffeeLoopBody: {
    id: 'rewards.universalBenefitBox.coffeeLoop.body',
    defaultMessage:
      'Our new punch card program that earns you a free brewed coffee after # qualifying purchases',
    description: 'Body text for coffee loop benefit card',
  },
  benefitsComingSoon: {
    id: 'rewards.universalBenefitBox.benefitsComingSoon',
    defaultMessage: 'Benefits information will be available soon.',
    description: 'Fallback message when no benefit cards are configured',
  },
});
